"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CursorMoveRe = /\x1b\[((?:\d*)(?:;\d*)*)([ABCDEFGHJKSTf])/;
var CSITable = {
    A: { name: 'up', maxParams: 1, default: 1 },
    B: { name: 'down', maxParams: 1, default: 1 },
    C: { name: 'forward', maxParams: 1, default: 1 },
    D: { name: 'back', maxParams: 1, default: 1 },
    E: { name: 'nextLine', maxParams: 1, default: 1 },
    F: { name: 'prevLine', maxParams: 1, default: 1 },
    G: { name: 'h-abs', maxParams: 1, default: 1 },
    H: { name: 'pos', maxParams: 2, default: 1 },
    J: { name: 'eraseInDis', maxParams: 1, default: 0 },
    K: { name: 'eraseInLine', maxParams: 1, default: 0 },
    S: { name: 'scrollUp', maxParams: 1, default: 1 },
    T: { name: 'scrollDown', maxParams: 1, default: 1 },
    f: { name: 'pos', maxParams: 2, default: 1 }
};
var parsePos = function (def, x) {
    var parsed = parseInt(x, 10);
    return isNaN(parsed) || parsed === 0 ? def : parsed;
};
var process = function (str) {
    var matched = str.match(CursorMoveRe);
    var result = [];
    if (matched) {
        if (matched.index > 0) {
            result.push(['text', str.slice(0, matched.index)]);
        }
        var key = matched[2];
        var codeDef = CSITable[key];
        var name_1 = codeDef.name, def = codeDef.default, maxParams = codeDef.maxParams;
        if (maxParams > 1) {
            var _a = matched[1].split(';'), x = _a[0], y = _a[1];
            result.push([name_1, parsePos(def, x), parsePos(def, y)]);
        }
        else {
            result.push([name_1, parsePos(def, matched[1])]);
        }
    }
    var left = matched ? str.slice(matched.index + matched[0].length) : str;
    return { result: result, left: left };
};
exports.default = process;
//# sourceMappingURL=csi-code.js.map